import { GlBadge, GlLoadingIcon } from '@gitlab/ui';
export default {
    name: 'DuoSingleSelectOptions',
    components: {
        GlBadge,
        GlLoadingIcon
    },
    props: {
        options: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        submittingId: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'select'
    ]
};
